// services

import AxiosInstanceCreator from 'services/api';
import {
  ReqRiskAssessmentStatus,
  ResRiskAssessmentStatus
} from '../models/riskAssessmentStatus.model';

// models

const riskAssessmentStatusInstance = new AxiosInstanceCreator({
  baseURL: `/v1/api/risk-assessment`
}).create();

/**
 * 위험 평가 상태 조회 API
 * @param {ReqRiskAssessmentStatus} params
 * @returns {Promise<ResRiskAssessmentStatus>}
 */
export const riskAssessmentStatusApi = {
  async getRiskAssessmentStatus(params: ReqRiskAssessmentStatus): Promise<ResRiskAssessmentStatus> {
    return await riskAssessmentStatusInstance.get(`/status`, { params }).then((res) => res.data);
  }
};
